import { CSSProperties } from "react";

import styles from "./styles.module.css";
import { useControlBar } from "../../contexts/ControlBar";
import { useRoot } from "../../contexts/Root";
import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { createPortal } from "react-dom";
import { Controls } from "../..";

interface Props {
  show: boolean;
  children: React.ReactNode;
}

export const Center = ({ show, children }: Props) => {
  const { controls } = useRoot();
  const { container } = useVideoPlayerRefs();
  const { isActive: isControlBarActive } = useControlBar();
  const {
    theme: { foreground },
  } = useRoot();

  const translateY =
    (controls === Controls.fullControlBar && -42.5) ||
    (controls === Controls.partialControlBar && -17.5) ||
    0;

  const style = {
    color: foreground,
    fill: foreground,
    opacity: show ? 1 : 0,
    transform: `translateY(${isControlBarActive ? translateY : 0}px)`,
  } as CSSProperties;

  return container.current !== null
    ? createPortal(
        <div style={style} className={styles.container}>
          {children}
        </div>,
        container.current
      )
    : null;
};
